module.exports = __webpack_public_path__ + "img/gba.a56c219b.png";